// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/customers/${file}.vue`);

export default [

    {
        path: "/customer",
        name: "customer-list",
        meta: { requiresAuth: true, applicationFeatureCode: "Customer" },
        components: {
            content: lazyLoad('customer-list'),
        },
    },
    {
        path: "/customer/create",
        name: "customer-detail-create",
        meta: { requiresAuth: true, applicationFeatureCode: "Customer" },
        components: {
            content: lazyLoad('customer-detail'),
        },
    },
    {
        path: "/customer/edit/:id",
        name: "customer-detail-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "Customer" },
        components: {
            content: lazyLoad('customer-detail'),
        },
    },
    {
        path: "/customer/review/:id",
        name: "customer-detail-review",
        meta: { requiresAuth: true, applicationFeatureCode: "Customer" },
        components: {
            content: lazyLoad('customer-detail'),
        },
    },

    {
        path: "/customer-delivery-address/:id",
        name: "customer-delivery-address",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerDeliveryAddress",
        },
        components: {
            content: lazyLoad('customer-delivery-address'),
        },
    },
    {
        path: "/customer-delivery-address/create/:id",
        name: "customer-delivery-address-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerDeliveryAddress",
        },
        components: {
            content: lazyLoad('customer-delivery-address'),
        },
    },
    {
        path: "/customer-delivery-address/review/:id",
        name: "customer-delivery-address-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerDeliveryAddress",
        },
        components: {
            content: lazyLoad('customer-delivery-address'),
        },
    },
    {
        path: "/customer-delivery-address/edit/:id",
        name: "customer-delivery-address-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerDeliveryAddress",
        },
        components: {
            content: lazyLoad('customer-delivery-address'),
        },
    },

    // Customer Contacts
    {
        path: "/customer-contact/:id",
        name: "customer-contact",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerContact",
        },
        components: {
            content: lazyLoad('customer-contact'),
        },
    },
    {
        path: "/customer-contact/create/:id",
        name: "customer-contact-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerContact",
        },
        components: {
            content: lazyLoad('customer-contact'),
        },
    },
    {
        path: "/customer-contact/review/:id",
        name: "customer-contact-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerContact",
        },
        components: {
            content: lazyLoad('customer-contact'),
        },
    },
    {
        path: "/customer-contact/edit/:id",
        name: "customer-contact-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerContact",
        },
        components: {
            content: lazyLoad('customer-contact'),
        },
    },

    // Customer Notes
    {
        path: "/customer-note/:id",
        name: "customer-note",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerNote",
        },
        components: {
            content: lazyLoad('customer-note'),
        },
    },
    {
        path: "/customer-note/create/:id",
        name: "customer-note-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerNote",
        },
        components: {
            content: lazyLoad('customer-note'),
        },
    },
    {
        path: "/customer-note/review/:id",
        name: "customer-note-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerNote",
        },
        components: {
            content: lazyLoad('customer-note'),
        },
    },
    {
        path: "/customer-note/edit/:id",
        name: "customer-note-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerNote",
        },
        components: {
            content: lazyLoad('customer-note'),
        },
    },

    // Customer Agent
    {
        path: "/customer-agent/:id",
        name: "customer-agent",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerAgent",
        },
        components: {
            content: lazyLoad('customer-agent'),
        },
    },
    {
        path: "/customer-agent/edit/:id",
        name: "customer-agent-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "CustomerAgent" },
        components: {
            content: lazyLoad('customer-agent'),
        },
    },
    {
        path: "/customer-agent/review/:id",
        name: "customer-agent-review",
        meta: { requiresAuth: true, applicationFeatureCode: "CustomerAgent" },
        components: {
            content: lazyLoad('customer-agent'),
        },
    },

    // customer-freight-charge
    {
        path: "/customer-freight-charge/:id",
        name: "customer-freight-charge",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "FreightCharge",
        },
        components: {
            content: lazyLoad('customer-freight-charge'),
        },
    },
    {
        path: "/customer-freight-charge/create/:id",
        name: "customer-freight-charge-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "FreightCharge",
        },
        components: {
            content: lazyLoad('customer-freight-charge'),
        },
    },
    {
        path: "/customer-freight-charge/review/:id",
        name: "customer-freight-charge-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "FreightCharge",
        },
        components: {
            content: lazyLoad('customer-freight-charge'),
        },
    },
    {
        path: "/customer-freight-charge/edit/:id",
        name: "customer-freight-charge-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "FreightCharge",
        },
        components: {
            content: lazyLoad('customer-freight-charge'),
        },
    },

    {
        path: "/customer-transaction-history/:id",
        name: "customer-transaction-history",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerTransactionHistory",
        },
        components: {
            content: lazyLoad('customer-transaction-history'),
        },
    },
    {
        path: "/customer-call-logs/:id",
        name: "customer-call-logs-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CallLogs",
        },
        components: {
            content: lazyLoad('customer-call-log-list'),
        },
    },
    {
        path: "/customer-surveys/:id",
        name: "customer-survey-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SurveyResponse",
        },
        components: {
            content: lazyLoad('customer-survey-list'),
        },
    },

    {
        path: "/delivery-address",
        name: "delivery-address-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerDeliveryAddress",
        },
        components: {
            content: lazyLoad('customer-delivery-address-list'),
        },
    },

    {
        path: "/customer-transaction",
        name: "customer-transaction",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerTransactionHistory",
        },
        components: {
            content: lazyLoad('customer-transaction'),
        },
    },

    // Customer Statements
    {
        path: "/customer-statement",
        name: "customer-statement-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ReportCustomerStatement",
        },
        components: {
            content: lazyLoad('customer-statement-list'),
        },
    },
    {
        path: "/customer-statement/create",
        name: "customer-statement-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ReportCustomerStatement",
        },
        components: {
            content: lazyLoad('customer-statement'),
        },
    },
    {
        path: "/customer-statement/edit/:id",
        name: "customer-statement-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ReportCustomerStatement",
        },
        components: {
            content: lazyLoad('customer-statement'),
        },
    },
    {
        path: "/customer-statement/review/:id",
        name: "customer-statement-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ReportCustomerStatement",
        },
        components: {
            content: lazyLoad('customer-statement'),
        },
    },

    {
        path: "/call-logs",
        name: "call-logs-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CallLogs",
        },
        components: {
            content: lazyLoad('call-log-list'),
        },
    },

    {
        path: "/surveys",
        name: "survey-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SurveyResponse",
        },
        components: {
            content: lazyLoad('survey-list'),
        },
    },

    {
        path: "/customer-custom-field/edit/:id",
        name: "customer-custom-field-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerCustomField",
        },
        components: {
            content: lazyLoad('customer-custom-field'),
        },
    },
    {
        path: "/customer-custom-field/review/:id",
        name: "customer-custom-field-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerCustomField",
        },
        components: {
            content: lazyLoad('customer-custom-field'),
        },
    },

    // CustomerCredit
    {
        path: "/credit-customer/create*",
        name: "customer-credit-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Invoice", // CreditCustomer
        },
        components: {
            content: lazyLoad('customer-credit'),
        },
    },
    {
        path: "/credit-customer/review/:id",
        name: "customer-credit-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Invoice", // CreditCustomer
        },
        components: {
            content: lazyLoad('customer-credit'),
        },
    },

    {
        path: "/customer-receipt/review/:id",
        name: "customer-receipt-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CashReceipt", // CreditCustomer
        },
        components: {
            content: lazyLoad('customer-receipt'),
        },
    },
    {
        path: "/customer-receipt/create",
        name: "customer-receipt-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CashReceipt",
        },
        components: {
            content: lazyLoad('customer-receipt'),
        },
    },
    {
        path: "/customer-receipt/create/:id",
        name: "customer-receipt-create-id",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CashReceipt",
        },
        components: {
            content: lazyLoad('customer-receipt'),
        },
    },

    // Call Logs
    {
        path: "/call-logs/create",
        name: "call-logs-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CallLogs",
        },
        components: {
            content: lazyLoad('create-call-log'),
        },
    },
    {
        path: "/call-logs/review/:id",
        name: "call-logs-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CallLogs",
        },
        components: {
            content: lazyLoad('create-call-log'),
        },
    },
    {
        path: "/call-logs/edit/:id",
        name: "call-logs-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CallLogs",
        },
        components: {
            content: lazyLoad('create-call-log'),
        },
    },

    // Surveys
    {
        path: "/surveys/create",
        name: "surveys-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CallLogs",
        },
        components: {
            content: lazyLoad('create-surveys-response'),
        },
    },
    {
        path: "/surveys/review/:id",
        name: "surveys-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CallLogs",
        },
        components: {
            content: lazyLoad('create-surveys-response'),
        },
    },
    {
        path: "/surveys/edit/:id",
        name: "surveys-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CallLogs",
        },
        components: {
            content: lazyLoad('create-surveys-response'),
        },
    },
    // customer-sample-request-list
    {
        path: "/customer-sample-requests",
        name: "customer-sample-request-list",
        meta: { requiresAuth: true, applicationFeatureCode: "SampleRequests" },
        components: {
            content: lazyLoad('customer-sample-request-list'),
        },
    },
    {
        path: "/customer-sample-requests/:id",
        name: "customer-sample-requests-list",
        meta: { requiresAuth: true, applicationFeatureCode: "SampleRequests" },
        components: {
            content: lazyLoad('customer-sample-requests'),
        },
    },

]; 